import * as Bowser from 'bowser';

import { Component, HostBinding, OnInit } from '@angular/core';

import { KantoorLoginService } from './kantoor-login.service';

@Component({
    selector: 'kantoor-login',
    templateUrl: './kantoor-login.component.html',
    standalone: false
})
export class KantoorLoginComponent implements OnInit {
    @HostBinding('class.ap-full-screen-footer-container') fullScreenContainer = true;

    public constructor(private kantoorLoginService: KantoorLoginService) {}

    public ngOnInit(): void {
        if (this.isBrowserIE()) {
            this.kantoorLoginService.navigateToBrowserPage();
        }
    }

    public isBrowserIE(): boolean {
        return Bowser.getParser(window.navigator.userAgent).isBrowser(Bowser.BROWSER_MAP.ie, true);
    }
}
